import PropTypes from 'prop-types';
import BetLegsDetailsImpl from './bet-legs-details.jsx';
import MojitoCore from 'mojito/core';

/**
 * Module that displays bet legs details content.
 *
 * @class BetLegsDetails
 * @name BetLegsDetails
 * @memberof Mojito.Modules
 */

/**
 * BetLegsDetails prop types.
 *
 * @property {Mojito.Services.Betslip.types.Bet} bet - Bet instance.
 *
 * @memberof Mojito.Modules.BetLegsDetails
 */
const propTypes = {
    bet: PropTypes.object.isRequired,
};

export default MojitoCore.Presentation.UIView('BetLegsDetails', BetLegsDetailsImpl, propTypes);
